<template>
	<div v-if="bannerData">
		<div class="panel has-border mb-0 banner-top-border" :class="[borderStyleClass, backgroundColorClass, {'full-radius': !bannerData.image_url}]">
			<h3 class="title is-2 has-text-white has-text-weight-bold banner-title has-cabin-font">
				{{ bannerData.title }}
			</h3>
			<div class="has-text-white has-text-weight-normal mb-4 marketing-banner" v-html="bannerData.description"></div>
			<button v-if="bannerData.cta_target"
					class="button has-full-width has-cabin-font track-action"
					:data-ta-event="'clientarea-track.home.' + bannerData.name + '.click'"
					data-ta-action="Click"
					:data-ta-label="'Home-page - Click on ' + bannerData.name + ' banner'"
					data-ta-page-name="Homepage"
					@click="clickBanner()"
					:class="{'is-loading' : bannerClickEvent.loading}">
				{{ bannerData.cta_label }}
			</button>
		</div>
		<div v-if="bannerData.image_url">
			<img :src="bannerData.image_url" alt="img-banner" class="banner-bottom-border">
		</div>
	</div>
</template>

<script>
import {ApiMonizze} from "../api-monizze";
export default
{
	props: {
		url: {
			type: String,
			required: true,
		},
		customerEmail: {
			type: String,
			required: true,
		},
		bannerLogEventRoute: {
			type: String,
			required: true,
		},
		currentCustomer: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			bannerData: null,
			bannerClickEvent: {
				loading: false,
			},
			borderStyleClass: '',
			backgroundColorClass: '',
		};
	},
	mounted() {
		this.fetchBannerData();
	},
	methods: {
		fetchBannerData()
		{
			(new ApiMonizze()).getDataFromApi(this.url, (data) => {
				this.bannerData = data;
				this.borderStyleClass = this.getStyleClass('has-border-', data.product_type);
				this.backgroundColorClass = this.getStyleClass('has-background-', data.product_type);

				(new ApiMonizze()).postDataFromApi(this.bannerLogEventRoute, {
					'event': 'clientarea-track.home.' + this.bannerData.name + '.view',
					'action': 'Visit',
					'label': 'Home-page – ' + this.bannerData.name + ' redirect to view',
					'page_name': 'HomePage',
					'customer': this.currentCustomer
				}, () => {});

				this.fetchBannerPromise = null;
			})
			.catch((error) => {
				//fail quietly
			});
		},
		clickBanner()
		{
			const { cta_target, new_tab } = this.bannerData;

			let url = cta_target;
			url = url.replace("{currentCustomer}", this.currentCustomer);

			if (new_tab)
			{
				window.open(url, "_blank");
			}
			else
			{
				window.location.href = url;
			}
		},
		getStyleClass(prefix, productType)
		{
			switch (productType)
			{
				case 'emv':
					return prefix + 'emv';
				case 'eco':
					return prefix + 'eco';
				case 'ecv':
					return prefix + 'ecv';
				case 'gift':
					return prefix + 'gift';
				case 'activ':
					return prefix + 'activ';
				case 'mobi':
					return prefix + 'mobi';
				default:
					return '';
			}
		}
	},
};
</script>

<style scoped>
	.has-cabin-font {
		font-family: "Cabin", sans-serif;
	}

	.banner-top-border {
		border-radius: 8px 8px 0 0;
	}

	.banner-bottom-border {
		border-radius: 0 0 8px 8px;
		width:100%;
	}

	.banner-title {
		font-style: normal;
		line-height: 40px;
	}

	.full-radius {
		border-radius: 8px !important;
	}
</style>
